<template>
    <q-btn
        color="primary"
        @click="openModal"
        label="Создать"
    >
        <q-modal
            v-model="transactionModalOpened"
            @show="$refs.unformattedAmount.focus()"
            content-css="width: 400px;"
        >
            <div class="q-pa-lg bill">
                Новая транзакция
                <q-field
                    :error="$v.transaction.unformattedAmount.$error"
                    error-label="Введите сумму транзакции"
                >

                    <q-input
                        ref="unformattedAmount"
                        v-model="transaction.unformattedAmount"
                        stack-label="Сумма"
                        type="number"
                    />

                    <q-field>
                        <q-option-group
                            v-model="transaction.mode"
                            :options="modeOptions"
                            inline
                            dense
                        />
                    </q-field>

                    <q-select
                        v-model="transaction.type"
                        :options="transactionTypes"
                        stack-label="Способ оплаты"
                    />

                    <q-select
                        v-model="transaction.reasonOption"
                        :options="filteredReasonOptions"
                        stack-label="Причина"
                        required
                        @change="toggleCommentField"
                    />

                    <q-field
                        v-if="showCommentField"
                    >
                        <q-input
                            v-model="transaction.reason"
                            stack-label="Комментарий"
                            type="text"
                        />
                    </q-field>
                </q-field>
            </div>
            <div class="row justify-end q-pa-lg">
                <q-btn label="Отмена" style="margin-right: 10px;" @click="transactionModalOpened=false"/>
                <q-btn label="Сохранить" color="primary" @click="createTransaction"/>
            </div>
        </q-modal>
    </q-btn>
</template>

<script>
import tableHelpers from 'components/HTable/helpers'
import api from 'mixins/api'
import makeCorrectAmount from 'mixins/makeCorrectAmount'
import columnsValues from '../HTable/columnsValues'

import { QBtn, QField, QInput, QModal, QOptionGroup, QSelect } from 'quasar'
import { required } from 'vuelidate/lib/validators'

export default {
    name: 'ProjectTransactionCreate',

    components: {
        QField,
        QInput,
        QSelect,
        QBtn,
        QModal,
        QOptionGroup,
    },

    mixins: [
        tableHelpers,
        api,
        makeCorrectAmount,
    ],

    data () {
        return {
            transactionModalOpened: false,

            transaction: {
                unformattedAmount: null,
                amount: null,
                type: null,
                mode: null,
                reason: null,
                reasonOption: null,
            },

            modeOptions: [
                { label: 'Бонусы', value: 'bonus' },
                { label: 'Баланс', value: 'balance' },
            ],

            reasonOptions: [
                { label: 'Бонус за отзыв', value: 'Бонус за отзыв' },
                { label: 'Бонус за интервью', value: 'Бонус за интервью' },
                { label: 'Пригласить друга', value: 'Пригласить друга' },
                { label: 'Партнерская награда', value: 'Партнерская награда' },
                { label: 'Другая (добавить комментарий)', value: 'other' },
            ],
        }
    },

    validations () {
        return {
            transaction: {
                unformattedAmount: {
                    required,
                },
                type: {
                    required,
                },
            },
        }
    },

    computed: {
        transactionTypes () {
            return columnsValues.transactionType
        },

        showCommentField () {
            return this.transaction.reasonOption === 'other' || this.transaction.mode === 'balance'
        },

        filteredReasonOptions () {
            if (this.transaction.mode === 'balance') {
                return [this.reasonOptions[this.reasonOptions.length - 1]]
            }

            return this.reasonOptions
        },
    },

    created () {
        this.transaction.type = this.transactionTypes[0].value
    },

    methods: {
        openModal () {
            this.transactionModalOpened = true
            this.transaction.mode = 'bonus'
            this.transaction.reasonOption = this.reasonOptions[0].value
        },

        createTransaction () {
            this.$v.transaction.$touch()

            if (this.$v.transaction.$error) {
                return
            }

            this.transaction.amount = this.formatNumber(this.transaction.unformattedAmount, 100)

            this.transactionModalOpened = false

            let transaction = this.transaction

            if (!transaction.reason) {
                transaction.reason = transaction.reasonOption
            }

            this.api.post(`/projects/${this.$route.params.id}/transactions`, this.transaction).then(() => {
                this.$q.notify({ message: 'Сохранено', type: 'positive' })
                this.$emit('transactionCreated', true)
                this.$v.transaction.$reset()
                this.clearTransactionData()
            }).catch(error => {
                console.error(error.response.data.message)
                this.$q.notify({ message: 'Ошибка', type: 'negative' })
            })
        },

        toggleCommentField () {
            this.showCommentField = this.transaction.reasonOption === 'other' || this.transaction.mode === 'balance'
        },

        clearTransactionData () {
            this.transaction.unformattedAmount = null
            this.transaction.amount = null
            this.transaction.reason = null
            this.transaction.type = null
            this.transaction.mode = null
            this.transaction.reasonOption = null
        },
    },
}
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// resources/assets/js/components/ProjectTransactions/ProjectTransactionCreate.vue